import axios from 'axios';
import { API_URL } from '../config';

const FARMER_URL = `${API_URL}/farmers`;

export const farmerService = {
    // Get all farmers
    getAllFarmers: async () => {
        const response = await axios.get(FARMER_URL);
        return response.data;
    },

    // Get a single farmer by ID
    getFarmer: async (id) => {
        const response = await axios.get(`${FARMER_URL}/${id}/`);
        return response.data;
    },

    // Create a new farmer
    createFarmer: async (farmerData) => {
        const response = await axios.post(FARMER_URL, farmerData);
        return response.data;
    },

    // Update a farmer
    updateFarmer: async (id, farmerData) => {
        const response = await axios.put(`${FARMER_URL}/${id}/`, farmerData);
        return response.data;
    },

    // Delete a farmer
    deleteFarmer: async (id) => {
        await axios.delete(`${FARMER_URL}/${id}/`);
    },

    // Get emissions data for a farmer
    getFarmerEmissions: async (id) => {
        const response = await axios.get(`${FARMER_URL}/${id}/emissions/`);
        return response.data;
    },
};